import React from 'react';
import type { CaseStudy, Project } from '../../types/content';
interface OverviewSidebarProps {
  project: Project;
  study: CaseStudy;
}
function Row({
  label,
  children
}: {
  label: string;
  children: React.ReactNode;
}) {
  return <div className="border-b border-hairline py-4" data-id="element-223" data-mp="al5bkhqwdszv">
      <dt className="text-[12px] uppercase tracking-[0.06em] text-muted" data-id="element-224" data-mp="5mvh69czywfb">{label}</dt>
      <dd className="mt-2 text-small leading-6 text-ink" data-id="element-225" data-mp="3e2f4ysuwfmmz">{children}</dd>
    </div>;
}
export function OverviewSidebar({
  project,
  study
}: OverviewSidebarProps) {
  return <div className="lg:sticky lg:top-[112px]" data-id="element-226" data-mp="395566mlmdymh">
      <p className="text-small font-medium text-ink" data-id="element-227" data-mp="3o14dhv0wnuqk">Overview</p>
      <dl className="mt-5 border-t border-hairline" data-id="element-228" data-mp="3ny8ee3dbn00j">
        <Row label="Client" data-id="element-229" data-mp="3j0gkx4x135u8">{project.client}</Row>
        <Row label="Industry" data-id="element-230" data-mp="3j3upmjt5zr4u">{study.overview.industry}</Row>
        <Row label="Location" data-id="element-231" data-mp="139191ooajoxp">{study.overview.location}</Row>
        <Row label="Year" data-id="element-232" data-mp="ybslt9oacupl">{project.year}</Row>
        <Row label="Timeline" data-id="element-233" data-mp="yarcpaqtyiai">{study.overview.timeline}</Row>
        <Row label="Scope designed" data-id="element-234" data-mp="rreawmpu3b6n">
          <ul className="space-y-1" data-id="element-235" data-mp="rq3b0xzienkt">
            {study.overview.services.map(service => <li key={service} data-id="element-236" data-mp="wo4ql8xq84rj">{service}</li>)}
          </ul>
        </Row>
      </dl>
    </div>;
}